import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';

//Helpers
import { showMessage } from 'helpers/message';
import mascaras from '../../helpers/mascaras';

//Contants
import { actionsTable } from '../../constants/MaterialTable';

//Components
import FichaInscricoesMunicipais from './FichaInscricoesMunicipais';
import NovoInscricoesMunicipais from './NovoInscricoesMunicipais';
import MainCard from '../../components/MainCard/MainCard';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';

//API
import inscricaoMunicipal_api from '../../api/inscricaoMunicipal_api';

//Context
import { useAuth } from '../../context/auth';
import { objCampo } from 'helpers/ValidadorDeCampos';
import { validarCampos } from 'helpers/ValidadorDeCampos';
import TextField from 'components/TextField/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';


function initialStateFiltrosInscricaoMunicipal() {
    return {
        cnpj: "",
        tbGerador_id: ""
    }
}
function InscricoesMunicipais() {
    //Dados do usuario logado
    const { session, setLoading } = useAuth()

    //State para pegar os dados referente ao gerador
    const [filtro, setFiltro] = useState(initialStateFiltrosInscricaoMunicipal())

    // guarda o estado para o botão de novo transportador
    const [novo, setNovo] = useState(false);

    // guarda o estado para os botão de visualização da ficha
    const [ficha, setFicha] = useState(null);

    const [listInscricoes, setListInscricoes] = useState([]);

    //State para pegar erros de campos obrigatorios
    const [errors, setErrors] = useState({})

    //Estado de controle dos headers da tabela
    const headers = [
        { value: "CNPJ", objectValue: "cnpj", align: "left" },
        { value: "Razão Social", objectValue: "razaoSocial", align: "left" },
        { value: "Inscrição Municipal", objectValue: "inscricaoMunicipal", align: "left" }
    ];

    const loadInscricoesMunicipais = (filtro) => {
        setLoading(true);
        inscricaoMunicipal_api.GetList(filtro).then(response => {
            setListInscricoes(response.data)
        }).catch(error => showMessage("Error", error.message, "error", null))
            .finally(() => setLoading(false))
    }

    const loadFiltrosinscricaoMunicipais = () => {
        if (session && session.acesso.sigla == "GS") {
            const _errors = validarCampos(filtro, campos);
            if (_errors[1].length > 0) {
                setErrors(_errors[0]);
                return;
            }
        }

        loadInscricoesMunicipais(filtro)
    }

    useEffect(() => {
        loadInscricoesMunicipais(filtro);
    }, []);

    // retorna a ficha caso tenha algo armazenado em seu estado
    if (ficha) {
        return <FichaInscricoesMunicipais
            btnVoltar={() => {
                setFicha(null);
                loadInscricoesMunicipais(filtro);
            }}
            id={ficha}
            filtro={filtro}
        />;
    }

    // retorna a tela de novo caso tenha algo armazenado em seu estado
    if (novo) {
        return <NovoInscricoesMunicipais
            btnVoltar={() => {
                setNovo(false);
                loadInscricoesMunicipais(filtro);
            }}
        />;
    }

    //Ações  da tabela
    const actions = [actionsTable.visualizar((item) => {
        setFicha(item.id)
        setFiltro({ ...filtro, tbGerador_id: item.tbGerador_id })
    })];

    //campos para validação
    const campos = [
        objCampo({ name: "cnpj", required: true, cnpj: true })
    ];

    //onChange para os outros campos conferindo se os obrigatorios estão vazios e mostrando erro se sim
    const onchangeFiltro = (e) => {
        const { name, value } = e.target;
        const _filtros = {
            ...filtro,
            [name]: value
        };

        const campo = campos.filter(c => c.name == name);
        const erros = validarCampos(_filtros, campo);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] });
        }

        setFiltro(_filtros);
    }

    return <MainCard noCard btnCadastro={"Adicionar"} onClickBtnCadastro={() => setNovo(true)} >
        {session && session.acesso?.sigla == "GS" &&
            <Row>
                <Col md={"12"} lg={"4"}>
                    <TextField
                        maxLength={"18"}
                        label={"* CNPJ"}
                        invalid={!!errors.cnpj}
                        value={filtro.cnpj}
                        onChange={onchangeFiltro}
                        name="cnpj"
                        mask={mascaras.cpfcnpjMask}
                    />
                </Col>
                <Col md={"12"} lg={"4"}>
                    <div className={`d-flex align-items-center m-0 my-4 py-1`}>
                        <Button color='primary' className='my-0' onClick={loadFiltrosinscricaoMunicipais}>
                            <FontAwesomeIcon icon={faFilter} /> Filtros
                        </Button>
                    </div>
                </Col>
            </Row>
        }
        <TabelaListagem
            actions={actions}
            headers={headers}
            items={listInscricoes}
            title={`Lista de inscrições municipais`}
            options={{
                print: false,
                search: true,
                pagination: true
            }}
        />
    </MainCard>
}

export default InscricoesMunicipais;